// src/constants/roles.js
// Rôles et hiérarchie des permissions Fynho - NE PAS MODIFIER

// Rôles administrateurs
export const ADMIN_ROLES = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN: 'ADMIN',
    EDITOR: 'EDITOR',
    SUPPORT: 'SUPPORT',
  };
  
  // Hiérarchie (niveau plus élevé = plus de pouvoir)
  export const ROLE_LEVEL = {
    SUPER_ADMIN: 4,
    ADMIN: 3,
    EDITOR: 2,
    SUPPORT: 1,
  };
  
  // Permissions par rôle
  export const PERMISSIONS = {
    SUPER_ADMIN: [
      'manage_admins',       // créer/modifier/supprimer des admins
      'view_audit_logs',
      'manage_listings',
      'validate_listings',
      'delete_listings',
      'manage_reservations',
      'manage_owners',
      'manage_quartiers',
      'manage_types',
      'manage_users',
      'manage_reviews',
      'manage_reports',
      'view_stats',
      'manage_payments',
    ],
    ADMIN: [
      'manage_listings',
      'validate_listings',
      'delete_listings',
      'manage_reservations',
      'manage_owners',
      'manage_quartiers',
      'manage_types',
      'manage_users',
      'manage_reviews',
      'manage_reports',
      'view_stats',
    ],
    EDITOR: [
      'manage_listings',
      'manage_reservations',
      'manage_quartiers',
      'manage_types',
    ],
    SUPPORT: [
      'view_reservations',
      'contact_clients',
      'view_reviews',
      'manage_reports',
    ],
  };
  
  // Rôles utilisateurs (côté public)
  export const USER_ROLES = {
    VISITOR: 'VISITOR',   // sans compte
    USER: 'USER',         // compte simple
    OWNER: 'OWNER',       // propriétaire
  };